exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checklist-item[data-v-a07c0ad6] {\n  overflow-y: auto;\n}\n@media screen and (max-height: 800px) {\n.checklist-item .contents-inner[data-v-a07c0ad6] {\n    padding-top: 20px;\n    padding-bottom: 20px;\n}\n}\n.checklist-item .contents-inner .button[data-v-a07c0ad6] {\n  color: #fff;\n}", ""]);

// exports
